import React from 'react'
import { Col, Card } from 'react-bootstrap'
import { formatCurrency } from '../../../helpers'
import Tooltip from '../../tooltip'
import { Icon } from 'icons'

const ColItem = ({
    icon,
    iconSize,
    id,
    title,
    value,
    tooltip,
    isDisplayed = true,
  }) => {
    return isDisplayed &&
      value &&
      ((!!value.incGST && !!value.exGST) ||
        (typeof value !== 'object' && !!value)) ? (
      <Col xs={12} md={6} className="mb-12">
        <Card>
          <Card.Body className="d-flex py-2 justify-content-between">
            <div className="d-flex">
              <Icon iconType={icon} size={iconSize ? iconSize : 1.4} primary />
              <div className="d-flex flex-column ml-2">
                <span className="card-body__title">{title}</span>
                {typeof value === 'object' ? (
                  <>
                    <div>
                      <span className="font-weight-bold">
                        {formatCurrency(value.incGST)}
                      </span>{' '}
                      <span className="card-body__gst">(Inc GST)</span>
                    </div>
                    <div>
                      <span className="font-weight-bold">
                        {formatCurrency(value.exGST)}{' '}
                      </span>{' '}
                      <span className="card-body__gst">(Ex GST)</span>
                    </div>
                  </>
                ) : (
                  <span className="font-weight-bold">
                    {formatCurrency(value)}
                  </span>
                )}
              </div>
            </div>
            <Tooltip
              header={tooltip.header || title}
              subHeading={tooltip.subHeading}
              text={tooltip.text}
            />
          </Card.Body>
        </Card>
      </Col>
    ) : null
  }

  export default ColItem